import { Button, Stack } from "@mui/material";
import React from "react";

const ActionButtons = ({
  handleSubmit,
  handleAddNew,
  handleCancel,
  isEdit,
  isView,
  enableSubmit,
  updateLabel = "Update",
  saveLabel = "Save"
}) => {
  return (
    <>
      <Stack direction={"row"} gap={1.5} mt={3} justifyContent={"end"}>
        {!isView && (
          <Button
            variant="contained"
            disabled={!enableSubmit}
            onClick={() => {
              handleSubmit();
            }}
          >
            {isEdit ? updateLabel : saveLabel}
          </Button>
        )}
        {(!isView && !isEdit) && (
          <Button variant="contained" onClick={handleAddNew}>
            {"Clear"}
          </Button>
        )}
        <Button variant="outlined" onClick={handleCancel}>
          Back
        </Button>
      </Stack>
    </>
  );
};

export default ActionButtons;
